import React from 'react';
import './features.css';

const Features = () => {
  return (
      <>
            <div className="br-features-container">
                <div className="br-features-card">
                    <div className="br-features-card-image">
                        <img src="" alt="Feature img" />
                    </div>
                    <div className="br-features-card-content">
                        <h3>ABOUT US</h3>
                        <p>Feature Description</p>
                        <button> View More</button>
                    </div>
                </div>
                <div className="br-features-card">
                    <div className="br-features-card-image">
                        <img src="" alt="Feature img" />
                    </div>
                    <div className="br-features-card-content">
                        <h3>OUR WORK</h3>
                        <p>Feature Description</p>
                        <button> View More</button>
                    </div>
                </div>
                <div className="br-features-card">
                    <div className="br-features-card-image">
                        <img src="" alt="Feature img" />
                    </div>
                    <div className="br-features-card-content">
                        <h3>OUR PROCESS</h3>
                        <p>Feature Description</p>
                        <button> View More</button>
                    </div>
                </div>
                <div className="br-features-card">
                    <div className="br-features-card-image">
                        <img src="" alt="Feature img" />
                    </div>
                    <div className="br-features-card-content">
                        <h3>SERVICES</h3>
                        <p>Feature Description</p>
                        <button> View More</button>
                    </div>
                </div>
                <div className="br-features-card">
                    <div className="br-features-card-image">
                        <img src="" alt="Feature img" />
                    </div>
                    <div className="br-features-card-content">
                        <h3>OUR TEAM</h3>
                        <p>Feature Description</p>
                        <button> View More</button>
                    </div>
                </div>
                <div className="br-features-card">
                    <div className="br-features-card-image">
                        <img src="" alt="Feature img" />
                    </div>
                    <div className="br-features-card-content">
                        <h3>OUR CONTACT</h3>
                        <p>Feature Description</p>
                        <button> Contact us Now</button>
                    </div>
                </div>
            </div>
      </>
  )
}

export default Features